import { render, staticRenderFns } from "./FaultEventAlarmDone.vue?vue&type=template&id=538887bc&scoped=true"
import script from "./FaultEventAlarmDone.vue?vue&type=script&lang=ts"
export * from "./FaultEventAlarmDone.vue?vue&type=script&lang=ts"
import style0 from "./FaultEventAlarmDone.vue?vue&type=style&index=0&id=538887bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538887bc",
  null
  
)

export default component.exports